import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from '../utils/env';

const baseQuery = fetchBaseQuery({ baseUrl: API_BASE_URL });

export const apiSlice = createApi({
  baseQuery,
  tagTypes: ['Admin'],
  endpoints: (builder) => ({
  }),
});
